export const SAVE_FACIAL_MAPPING_DATA = "SAVE_FACIAL_MAPPING_DATA";
export const SAVE_NOTES_DATA = "SAVE_NOTES_DATA";
export const SAVE_TREATMENT_DATA = "SAVE_TREATMENT_DATA";
export const SAVE_BEFORE_AND_AFTER_DATA = "SAVE_BEFORE_AND_AFTER_DATA";
export const SAVE_BATCH_NUMBER_DATA = "SAVE_BATCH_NUMBER_DATA";
export const DELETE_BATCH_NUMBER_DATA = "DELETE_BATCH_NUMBER_DATA";
export const CLEAR_WALKIN_COMPLIANCES_DATA = "CLEAR_WALKIN_COMPLIANCES_DATA";

export const SAVE_BEFORE_AND_AFTER_DATA_AFTER_TREATMENT_REMOVED = "SAVE_BEFORE_AND_AFTER_DATA_AFTER_TREATMENT_REMOVED";
export const SAVE_BATCH_NUMBER_DATA_AFTER_TREATMENT_REMOVED = "SAVE_BATCH_NUMBER_DATA_AFTER_TREATMENT_REMOVED";

export const SAVE_UPLOADED_FACIAL_MAPPING_IMAGE = "SAVE_UPLOADED_FACIAL_MAPPING_IMAGE";
export const CLEAR_UPLOADED_FACIAL_MAPPING_IMAGE = "CLEAR_UPLOADED_FACIAL_MAPPING_IMAGE";